module.exports = __webpack_public_path__ + "img/award_text.0eb17f8c.png";